var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdDomainController(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Custom/ad domain controller@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Custom/ad-domain-controller",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arch-Category_Customer-Enablement_64"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E2E9F7",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SERVER",
    mask: "url(#mask-2)",
    fill: "#3267D6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9, 5)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0000005,0 C15.1031246,0 16.0000005,0.895312309 16.0000005,2 L16.0000005,4 C16.0000005,5.10468769 15.1046877,6 14.0000005,6 L2.00000048,6 C0.895312759,6 4.76837158e-07,5.10468769 4.76837158e-07,4 L4.76837158e-07,2 C4.76837158e-07,0.895312309 0.895312759,0 2.00000048,0 Z M10.9999997,2.25 C10.5859372,2.25 10.2499997,2.58562469 10.2499997,3 C10.2499997,3.4140625 10.5859372,3.75 10.9999997,3.75 C11.4140622,3.75 11.7499997,3.41562462 11.7499997,3 C11.7499997,2.58437538 11.4156243,2.25 10.9999997,2.25 Z M12.9999996,2.25 C12.5859371,2.25 12.2499996,2.58562469 12.2499996,3 C12.2499996,3.4140625 12.5859371,3.75 12.9999996,3.75 C13.4140621,3.75 13.7499996,3.41562462 13.7499996,3 C13.7499996,2.58437538 13.4156242,2.25 12.9999996,2.25 Z M14,8 C15.1031242,8 16,8.89687538 16,10 L16,12 C16,13.1046877 15.1046872,14 14,14 L2,14 C0.895312283,14 0,13.1046877 0,12 L0,10 C0,8.89531231 0.895312759,8 2,8 Z M10.9999997,10.25 C10.5859372,10.25 10.2499997,10.5856247 10.2499997,11 C10.2499997,11.4140625 10.5859372,11.75 10.9999997,11.75 C11.4140622,11.75 11.7499997,11.4140625 11.7499997,11 C11.7499997,10.5843754 11.4156243,10.25 10.9999997,10.25 Z M12.9999996,10.25 C12.5859371,10.25 12.2499996,10.5856247 12.2499996,11 C12.2499996,11.4140625 12.5859371,11.75 12.9999996,11.75 C13.4140621,11.75 13.7499996,11.4140625 13.7499996,11 C13.7499996,10.5843754 13.4156242,10.25 12.9999996,10.25 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.5, 21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#ADBEDE",
    x: 9.5,
    y: 0,
    width: 1,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#ADBEDE",
    transform: "translate(10, 6) rotate(-270) translate(-10, -6)",
    x: 9.5,
    y: -4,
    width: 1,
    height: 20
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3267D6",
    cx: 10,
    cy: 5.5,
    r: 2.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdDomainController);
export default __webpack_public_path__ + "static/media/ad-domain-controller.8a0720cf05e162613dac7d8cb9eb9025.svg";
export { ForwardRef as ReactComponent };